var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.4074 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Cell Phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1847,2.2662h3.1972c.2255,0,.4083-.1828.4083-.4084,0-.2254-.1828-.4082-.4083-.4082h-3.1972c-.2255,0-.4083.1828-.4083.4082,0,.2256.1828.4084.4083.4084Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.683,22.2324H3.8837c-.1034,0-.1872.0839-.1872.1872s.0839.1872.1872.1872h5.7993c.1034,0,.1872-.0839.1872-.1872s-.0839-.1872-.1872-.1872Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.171,6.4553h-.0916V1.968c0-1.087-.8811-1.968-1.968-1.968H2.235C1.1482,0,.267.8811.267,1.968v1.314h-.0306c-.1306,0-.2364.1059-.2364.2364v.9671c0,.1305.1059.2364.2364.2364h.0306v.7524h-.0306c-.1306,0-.2364.1059-.2364.2364v1.7732c0,.1305.1059.2364.2364.2364h.0306v.3855h-.0306c-.1306,0-.2364.1059-.2364.2365v1.773c0,.1306.1059.2365.2364.2365h.0306v11.6803c0,1.087.8811,1.968,1.968,1.968h8.8764c1.0869,0,1.968-.8811,1.968-1.968v-12.3578h.0916c.1306,0,.2364-.1059.2364-.2364v-2.7462c0-.1305-.1059-.2364-.2364-.2364h0ZM12.2834,22.0304c0,.6593-.5344,1.1935-1.1935,1.1935H2.2565c-.6591,0-1.1935-.5342-1.1935-1.1935V1.9693c0-.6591.5344-1.1933,1.1935-1.1933h8.8334c.6591,0,1.1935.5342,1.1935,1.1933v20.0611Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f721958d9c50204f0f26a5f8dafef1cf.svg";
export { ForwardRef as ReactComponent };